<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary sp-margin__bottom-x2">
      {{ 'COMPANIES.TICKET_TITLE' | translate }}
    </h3>

    <form
      [formGroup]="company_order_ticket_requirements_from_group"
      class="sp-column">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> Min </mat-label>
        <input
          matInput
          type="number"
          required
          formControlName="min_amount"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> Max </mat-label>
        <input
          matInput
          type="number"
          required
          formControlName="max_amount"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-slide-toggle
        class="sp-margin__bottom-x2"
        formControlName="is_bnpl_long_enabled">
        <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.LONG_PAYMENT_LABEL' | translate }}</p>
      </mat-slide-toggle>

      <mat-slide-toggle
        class="sp-margin__bottom-x2"
        formControlName="is_sdd_payment_enabled">
        <p class="sp-color__primary sp-margin__left">{{ 'COMPANIES.SDD_PAYMENT_LABEL' | translate }}</p>
      </mat-slide-toggle>

      <p
        class="sp-color__primary sp-margin__top sp-margin__bottom-x2"
        [innerHTML]="'COMPANIES.SET_ORDER_REQUIREMENTS_LABEL' | translate : { company_business_name }"></p>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_edit_running"
        [is_spinner_visible]="is_edit_running"
        (click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
